export const fmt = {
  currency: (v) => `KES ${Number(v || 0).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
  number:   (v) => Number(v || 0).toLocaleString('en-KE'),
  pct:      (v) => `${Number(v || 0).toFixed(1)}%`,
  date:     (d) => new Date(d).toLocaleDateString('en-KE', { day: 'numeric', month: 'short', year: 'numeric' }),
  datetime: (d) => new Date(d).toLocaleString('en-KE', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }),
  time:     (d) => new Date(d).toLocaleTimeString('en-KE', { hour: '2-digit', minute: '2-digit' }),
  initials: (name) => name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || '??',
};

export function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function debounce(fn, delay) {
  let t;
  return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), delay); };
}
